/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState, useEffect } from "react";
import { Modal, Tab, Table, Badge } from "react-bootstrap";
import CustomTab from "../SwitchTab";
import "./style.css";
import { getDateFormat } from "../../utils";
import Auditor from "../../icons/Auditor.svg?react";
import Auditee from "../../icons/Auditee.svg?react";
import { getAttendeesList, getQuestionnaireDetails } from "../../api/common";
interface TeamMember {
  name: string;
  email: string;
  role?: string;
  organization?: string;
}
interface ResponseData {
  auditors: any[];
  auditees: any[];
}
interface AuditInformationModalProps {
  show: boolean;
  onHide: () => void;
  element?: any;
}
interface QuestionData {
  questionCount: number;
  sentBy: any;
  sentOn: any;
  status: string;
}
const AuditInformationModal: React.FC<AuditInformationModalProps> = ({
  show,
  onHide,
  element,
}) => {
  const [activeKey, setActiveKey] = useState<string>("members");
  const [responseData, setResponseData] = useState<ResponseData | null>();
  const [questionData, setQuestionData] = useState<QuestionData | null>();

  useEffect(() => {
    setActiveKey("members");
    if (show) {
      getAttendeesList(element.auditingId!).then((response: any) => {
        setResponseData(response);
      });
      getQuestionnaireDetails(element.auditingId).then((response: any) => {
        setQuestionData(response);
      });
    }
  }, [show]);

  const tabData = [
    { text: "Members", key: "members" },
    { text: "Preparation", key: "preparation" },
    { text: "Data Collection Stages", key: "dataCollectionStages" },
  ];

  const handleTabChange = useCallback((key: string | null) => {
    if (key) setActiveKey(key);
  }, []);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      backdrop="static"
      dialogClassName="audit-modal"
      style={{ padding: "10px" }}
      enforceFocus={false}
    >
      <Modal.Header
        closeButton
        className="mt-3"
        style={{ backgroundColor: "#F5F5F5" }}
      >
        <h4>
          Information:&nbsp;
          <span className="text-decoration-none" style={{ color: "#102351" }}>
            {element?.auditCode}
          </span>
        </h4>
      </Modal.Header>

      <Modal.Body>
        <Tab.Container
          activeKey={activeKey}
          onSelect={(k) => setActiveKey(k || "members")}
        >
          <CustomTab
            data={tabData}
            activeKey={activeKey}
            onTabChange={handleTabChange}
            alignWithFilter={true}
            customTab="mb-3 customTab"
            top={0}
          />

          <Tab.Content>
            {/* ================= MEMBERS TAB ================= */}
            <Tab.Pane eventKey="members">
              <div className="mb-4">
                {/* Common Audit Info */}
                <div className="d-flex justify-content-between mb-3">
                  <p className="fw-semibold mb-0">
                    <span className="text-secondary">Audit Created By:</span>{" "}
                    {element?.createdBy?.name || element?.createdBy?.username || "-"}
                  </p>
                  <p className="fw-semibold mb-0">
                    <span className="text-secondary">Audit Created On:</span>{" "}
                    {getDateFormat(element.createdOn, "DD/MM/YYYY")}
                  </p>
                </div>

                {/* ==================== AUDITOR TEAM ==================== */}
                <div className="table-scroll-wrapper mb-4">
                  <h4 className="fw-semibold mb-2 pb-2">Auditor Team</h4>
                  <div className="table-scroll-container">
                    <Table bordered className="align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Auditor Name</th>
                          <th>Auditor Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {element?.auditorMembers &&
                          element.auditorMembers.length > 0 ? (
                          element.auditorMembers.map((m: any, i: number) => (
                            <tr key={i}>
                              <td>{m.name}</td>
                              <td>{m.email}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={2} className="text-center text-muted">
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>

              {/* ==================== AUDITEE TEAM ==================== */}
              <div className="table-scroll-wrapper mb-4">
                <h4 className="fw-semibold mb-2 pb-2">Auditee Team</h4>
                <div className="table-scroll-container">
                  <Table bordered className="align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Organization</th>
                        <th>Auditee Name</th>
                        <th>Auditee Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {element?.organizations?.length ? (
                        element.organizations.map((org: any) => {
                          const auditeeLeads = org.auditeeLead || [];
                          const auditeeMembers = org.auditeeMembers || [];
                          const allMembers = [
                            ...auditeeLeads,
                            ...auditeeMembers,
                          ];
                          const uniqueMembers = allMembers.filter(
                            (member, index, self) =>
                              index ===
                              self.findIndex(
                                (m) =>
                                  m.email?.toLowerCase() ===
                                  member.email?.toLowerCase()
                              )
                          );

                          if (uniqueMembers.length === 0)
                            return (
                              <tr key={org.organizationId}>
                                <td>{org.organizationName}</td>
                                <td
                                  colSpan={2}
                                  className="text-center text-muted"
                                >
                                  No data available
                                </td>
                              </tr>
                            );

                          return uniqueMembers.map((m: any, index: number) => {
                            const isLead = auditeeLeads.some(
                              (lead: any) =>
                                lead.email?.toLowerCase() ===
                                m.email?.toLowerCase()
                            );
                            return (
                              <tr key={`${org.organizationId}-${index}`}>
                                {index === 0 && (
                                  <td
                                    rowSpan={uniqueMembers.length}
                                    className="align-middle"
                                  >
                                    {org.organizationName}
                                  </td>
                                )}
                                <td>
                                  {m.name} {isLead && "(TL)"}
                                </td>
                                <td>{m.email}</td>
                              </tr>
                            );
                          });
                        })
                      ) : (
                        <tr>
                          <td colSpan={3} className="text-center text-muted">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Tab.Pane>

            {/* ================= PREPARATION TAB ================= */}
            <Tab.Pane eventKey="preparation">
              {activeKey === "preparation" && (
                <div className="preparation-section">
                  {/* Kick-off Meeting */}
                  <h4 className="fw-semibold mb-3 pb-2">
                    Kickoff Meeting:&nbsp;{" "}
                    {!element?.isKickoffRequired ? "Exempted" : element?.kickOffFromDate && element?.kickOffToDate
                      ? getDateFormat(element.kickOffFromDate, "DD/MM/YYYY") +
                      " - " +
                      getDateFormat(element.kickOffFromDate, "hh:mm A") +
                      " to " +
                      getDateFormat(element.kickOffToDate, "hh:mm A")
                      : null}
                  </h4>
                  {/* Attendees Table (merged org) */}
                  {element?.isKickoffRequired && <div className="table-scroll-wrapper">
                    <div className="table-scroll-container">
                      <Table bordered className="align-middle mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>Participants</th>
                            <th>Attendee Name</th>
                            <th>Attendee Email ID</th>
                            <th>Acceptance Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {responseData &&
                            (responseData.auditors?.length ||
                              responseData.auditees?.length) ? (
                            (() => {
                              const orgMap: Record<string, any[]> = {};
                              responseData.auditees?.forEach((org: any) => {
                                orgMap[org.organizationName] =
                                  org.attendees.map((a: any) => ({
                                    name: a.attendeeName,
                                    email: a.attendeeEmail,
                                    acceptanceStatus: a.acceptanceStatus,
                                    teamLead: a.teamLead,
                                  }));
                              });
                              if (responseData.auditors?.length) {
                                orgMap["Auditor"] =
                                  responseData.auditors.map((a: any) => ({
                                    name: a.attendeeName,
                                    email: a.attendeeEmail,
                                    acceptanceStatus: a.acceptanceStatus,
                                    teamLead: a.teamLead,
                                  }));
                              }

                              return Object.entries(orgMap).flatMap(
                                ([orgName, members]: any) =>
                                  members.map((m: any, index: number) => (
                                    <tr key={`${orgName}-${m.email}`}>
                                      {index === 0 && (
                                        <td
                                          rowSpan={members.length}
                                          className="align-middle"
                                        >
                                          {orgName}
                                        </td>
                                      )}
                                      <td>
                                        {m.name} {m.teamLead && "(TL)"}
                                      </td>
                                      <td>{m.email}</td>
                                      <td className="text-center">
                                        {m.acceptanceStatus === "accepted" ? (
                                          <Badge className="status-badge px-3 py-2 rounded-pill force-green">
                                            Accepted
                                          </Badge>
                                        ) : m.acceptanceStatus ===
                                          "declined" ? (
                                          <Badge
                                            bg="danger"
                                            className="status-badge px-3 py-2 rounded-pill force-red"
                                          >
                                            Declined
                                          </Badge>
                                        ) : (
                                          <Badge
                                            bg="warning"
                                            text="dark"
                                            className="status-badge px-3 py-2 rounded-pill force-yellow"
                                          >
                                            Pending
                                          </Badge>
                                        )}
                                      </td>
                                    </tr>
                                  ))
                              );
                            })()
                          ) : (
                            <tr>
                              <td
                                colSpan={4}
                                className="text-center text-muted"
                              >
                                Yet to be Scheduled
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>}

                  {/* Questionnaire Status */}
                  <h4 className="fw-semibold mt-4 pb-2">
                    Questionnaire Status:&nbsp;
                  </h4>
                  <div className="table-scroll-wrapper mb-4">
                    <div className="table-scroll-container">
                      <Table bordered className="align-middle mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>No. of Questions</th>
                            <th>Questions Sent By</th>
                            <th>Questions Sent On</th>
                          </tr>
                        </thead>
                        <tbody>
                          {questionData &&
                            questionData.status !== "Not Triggered" ? (
                            <tr>
                              <td className="text-center">
                                {questionData?.questionCount}
                              </td>
                              <td className="text-center">
                                {questionData?.sentBy}
                              </td>
                              <td className="text-center">
                                {getDateFormat(
                                  questionData?.sentOn,
                                  "DD/MM/YYYY"
                                )}
                              </td>
                            </tr>
                          ) : (
                            <tr>
                              <td
                                colSpan={3}
                                className="text-center text-muted"
                              >
                                Yet to be Sent
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="dataCollectionStages">
              {activeKey === "dataCollectionStages" && (
              <>
              <div className="mb-4">
                {/* Common Audit Info */}
                <div className="d-flex justify-content-between mb-3">
                  <p className="fw-semibold mb-0">
                    <span className="text-secondary">Current Data Collection Stage:</span>{" "}
                    {Array.isArray(element?.sequenceDetails?.sequenceName)
                      ? element?.sequenceDetails?.sequenceName.join(", ")
                      : element?.sequenceDetails?.sequenceName || (element?.readyToClosure === true ? "All Stages Completed" : "-")}
                  </p>
                  <p className="fw-semibold mb-0">
                    <span className="text-secondary">Auditor Action:</span>{" "}
                    {
                    element?.sequenceDetails?.responseValidationRequired === false && element?.sequenceDetails?.questionValidationRequired === false ? "No Action Pending":
                    element?.sequenceDetails?.responseValidationRequired === false && element?.sequenceDetails?.questionValidationRequired === true ? "Send Question Pending":
                    element?.sequenceDetails?.responseValidationRequired === true && element?.sequenceDetails?.questionValidationRequired === false ? "Response Review Pending":
                    element?.readyToClosure === true ? "Move to Closure": "-"
                
                    }
                  </p>
                </div>
              </div>
              <div className="table-scroll-wrapper mb-4">
                <h4 className="fw-semibold mb-2 pb-2">Data Collection Stages</h4>
                <div className="table-scroll-container">
                  <Table bordered className="align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: '20%' }}>Data Collection Order</th>
                        <th>Data Collection Stages Name</th>
                        <th>Auditor Review</th>
                      </tr>
                    </thead>
                    <tbody>
                      {element?.auditSequences && element.auditSequences.length > 0 ? (
                        element.auditSequences.map((a: any, index: number) => (
                          <tr key={a.sequence?.[0]?.sequenceOrderId || index}>
                            <td className="text-center">
                              {a.sequenceOrderId}
                            </td>
                            <td>
                              {a.sequence?.length > 0
                                ? a.sequence.map((s: { sequenceName: string }) => s.sequenceName).join(", ")
                                : "-"}
                            </td>
                            <td>
                              {a.questionValidationRequired && a.responseValidationRequired
                                ? "Before Sending Questions, After AI review responses"
                                : a.questionValidationRequired
                                  ? "Before Sending Questions"
                                  : a.responseValidationRequired
                                    ? "After AI review responses"
                                    : !a.questionValidationRequired && !a.responseValidationRequired
                                      ? "Fully automated(No manual review)"
                                      : "-"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={3} className="text-center text-muted">No data available</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
              </>
              )}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>
    </Modal>
  );
};

export default AuditInformationModal;
